import styled from 'styled-components'

export const CCPSelectButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 5px 10px;
  border: 1px solid #c6c6c6;
  border-radius: 4px;
  background: ${(props) => props?.selected && '#d8ffd1'};
`

export const CCPSelectButtonSelectedDot = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: green;
`

export const CCPSelectButton = ({ text, clickAction, selected, icon }) => {
  return (
    <CCPSelectButtonContainer selected={selected} onClick={clickAction}>
      {text}
      {icon && icon}
      {selected && <CCPSelectButtonSelectedDot />}
    </CCPSelectButtonContainer>
  )
}
